import './SocialPostsExplorerPage.css';

import { useLoginContext } from '../../../App';
import Banner from '../../b2b-common/Banner';
import React, { useState } from 'react';
import ElementsCarousel from '../../b2b-common/ElementsCarousel';
import useTemplates from '../hooks/useTemplates';
import TemplateCard from '../components/TemplateCard';
import { useContentContext } from '../../layout/Layout';
import { fetchTemplateInstancesFromOrganization } from '../../../services/b2b-social-apiServices';
import { showNotification } from '../../b2b-common/Notification';
import B2BElementsExplorerInMemory from '../../b2b-common/B2BElementsExplorerInMemory';
import PostCard from '../components/posts/PostCard';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const SocialPostsExplorerPage = () => {

    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-social');
    const { setNotification } = useContentContext();

    const { templates } = useTemplates();

    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [posts, setPosts] = useState(null);
    const [fetchingPosts, setFetchingPosts] = useState(false);

    const getPosts = async (templateId) => {
        try {
            setFetchingPosts(true);
            let fetchedPosts = await fetchTemplateInstancesFromOrganization(loginData.accessToken, templateId);
            if (!fetchedPosts) {
                fetchedPosts = [];
            }
            fetchedPosts.forEach(post => post.socialPostInstancePayload = JSON.parse(post.socialPostInstancePayload));
            // console.log('Fetched posts:', fetchedPosts);
            setPosts(fetchedPosts);
            return fetchedPosts;
        } catch (error) {
            console.error('Error fetching posts: ' + error.message);
            showNotification(setNotification, t('Error fetching posts: ') + error.message, 'error', 5000);
        } finally {
            setFetchingPosts(false);
        }
    };

    const handleSelectTemplate = async (element) => {
        const template = element.props.template;
        if (!selectedTemplate) {
            setSelectedTemplate(template);
            await getPosts(template.socialPostTemplateId);
            return;
        }
        if (template.socialPostTemplateId === selectedTemplate.socialPostTemplateId) {
            return;
        }
        setSelectedTemplate(template);
        setPosts(null); // truco indio para que se refresquen las plantillas
        const newPosts = await getPosts(template.socialPostTemplateId);
        setPosts(newPosts);
    };

    const handleRefreshPosts = async () => {
        if (selectedTemplate) {
            await getPosts(selectedTemplate.socialPostTemplateId);
        }
    };

    return (
        <div className="social-posts-explorer-page">
            <Banner message={t('Social posts')} headingLevel='h1' underline={false} />
            <Banner message={t('Applicable templates')} headingLevel='h2' underline={false} />
            <ElementsCarousel
                elements={templates ? templates.map(template =>
                    <TemplateCard key={template.socialPostTemplateId} template={template} onRefresh={handleRefreshPosts} />
                ) : []}
                onElementSelect={handleSelectTemplate}
                className={'templates-carousel'}
            />
            <Banner message={t('Currents posts') + ` [${posts ? posts.length : 0}]`} headingLevel='h2' underline={false} />
            {fetchingPosts && <p>{t('Fetching posts...')}</p>}
            {/* {!fetchingPosts && !posts && <p>{t('No posts found or template has not been selected.')}</p>} */}

            <B2BElementsExplorerInMemory
                elementsData={{ content: posts ?? [] }}
                className={'posts-explorer'}
                ElementComponent={PostCard}
                elementComponentPropName={'post'}
                otherComponentProps={{ template: selectedTemplate }}
                elementComponentHandlers={{ onRefresh: handleRefreshPosts }}
                currentPage={1}
                numRows={posts? posts.length : 0}
            />

        </div>
    );
}

export default SocialPostsExplorerPage;